/* FERRY AUTO-GENERATED: DO NOT EDIT THIS FILE */ /* eslint-disable */ // @ts-nocheck
import * as image from "../../common/image";
import * as video from "../../common/video";
export { image, video };
export var InvitationDataIDLInit = {
  InvitationDataIDLInit_Default: 1
};
export var NotInvitableType = {
  INVITED: 1,
  REACHED_MAX_CREATOR_SIZE: 2,
  MISSING_INFORMATION: 3
};
export var InvitationGroupStatus = {
  INVITATION_GROUP_STATUS_UNSPECIFIED: 0,
  INVITATION_GROUP_STATUS_LIVE: 1,
  INVITATION_GROUP_STATUS_EXPIRING: 2,
  INVITATION_GROUP_STATUS_DELETING: 3,
  INVITATION_GROUP_STATUS_ENDED: 4,
  INVITATION_GROUP_STATUS_VALID: 5
};
export var InvitationProductStatus = {
  ProductStatus_UNSPECIFIED: 0,
  ProductStatus_LIVE: 1,
  ProductStatus_OUT_OF_STOCK: 2,
  ProductStatus_SELLER_DEACTIVATE: 3,
  ProductStatus_PLATFORM_DEACTIVATE: 4,
  ProductStatus_GNE_REJECT: 5
};
export var InvitationGroupProductStatus = {
  INVITATION_GROUP_PRODUCT_STATUS_NORMAL: 1,
  INVITATION_GROUP_PRODUCT_STATUS_DELETING: 2,
  INVITATION_GROUP_PRODUCT_STATUS_DELETED: 3
};
export var InvitationPairEffectiveStatus = {
  IPES_UNSPECIFIED: 0,
  IPES_EFFECTIVE_ALL: 1,
  IPES_EFFECTIVE_PARTIALLY: 2,
  IPES_EFFECTIVE_NONE: 3
};
export var AffiliateCreatorType = {
  AFFILIATE_CREATOR_TYPE_UNSPECIFIED: 0,
  AFFILIATE_CREATOR_TYPE_NORMAL: 1,
  AFFILIATE_CREATOR_TYPE_SELF_SOLD: 2
};
export var CreatorPermissionTag = {
  A1: 1,
  A2: 2,
  Other: 3
};
export var CanNotConnectType = {
  SELLER_BLOCK: 1,
  CREATOR_BLOCK: 2,
  FAN_THRESHOLD: 3
};
export var InvitationGroupCreatorStatus = {
  INVITATION_GROUP_CREATOR_STATUS_NORMAL: 1,
  INVITATION_GROUP_CREATOR_STATUS_DELETING: 2,
  INVITATION_GROUP_CREATOR_STATUS_DELETED: 3
};
export var GroupType = {
  GROUP_TYPE_NORMAL: 1,
  GROUP_TYPE_PLAN: 2,
  GROUP_TYPE_PEARL: 3,
  GROUP_TYPE_CAMPAIGN: 4
};
export var ContentType = {
  ContentType_NoPrefer: 0,
  ContentType_Video: 1,
  ContentType_Live: 2
};